<template>
  <div>
    <NotificationInPage
      actionText="Deactivate"
      :notification="$options.deactivateNotification"
      :showNotification="true"
      @action="handleShowDeactivateModal"
    />
    <PasswordManagerConfirmDeactivateModal
      :showModal="showDeactivateModal"
      @close="handleCloseDeactivateModal"
    />
  </div>
</template>

<script>
import {
  NotificationInPage,
  Types,
} from '@jumpcloud/ui-components';

import PasswordManagerConfirmDeactivateModal from 'client/PasswordManager/components/PasswordManagerConfirmDeactivateModal.vue';

const { NotificationConfig } = Types;

const deactivateNotification = NotificationConfig({
  icon: 'error',
  message: 'This irreversible action will deactivate password manager from all users\' devices and will erase all items stored in the password manager. Don\'t click the Deactivate button until users have exported their data from password manager.',
  title: 'Deactivate Password Manager',
  showCloseButton: false,
  type: 'error',
});

export default {
  name: 'PasswordManagerDeactivateSection',

  components: {
    NotificationInPage,
    PasswordManagerConfirmDeactivateModal,
  },

  deactivateNotification,

  data() {
    return {
      showDeactivateModal: false,
    };
  },

  methods: {
    handleCloseDeactivateModal() {
      this.showDeactivateModal = false;
    },

    handleShowDeactivateModal() {
      this.showDeactivateModal = true;
    },
  },
};

</script>
